import _extends from "@babel/runtime-corejs3/helpers/extends";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import * as React from 'react';
import classNames from 'classnames';
var ConditionFilter = function ConditionFilter(props) {
  var value = props.value,
    prefixCls = props.prefixCls,
    conditions = props.conditions,
    FilterLangMsg = props.FilterLangMsg,
    onConditionRemove = props.onConditionRemove,
    onConditionChange = props.onConditionChange;
  var handleConditionFilter = function handleConditionFilter(condition, option) {
    if (!option.component) {
      var conditionValue = value[condition.key];
      var optionValue = option.value;
      var optionIndex = conditionValue === null || conditionValue === void 0 ? void 0 : conditionValue.indexOf(optionValue);
      var nextValue = _extends({}, value);
      delete nextValue.scheme;
      var isSingleReSelect = !condition.multiple && conditionValue && conditionValue[0] === optionValue;
      if (conditionValue && condition.multiple) {
        if (optionIndex > -1) {
          var isRequiredLastOptionReSelect = condition.required && conditionValue.length === 1 && conditionValue[0] === optionValue;
          if (!isRequiredLastOptionReSelect) {
            var _context;
            conditionValue.length === 1 ? delete nextValue[condition.key] : _spliceInstanceProperty(_context = nextValue[condition.key]).call(_context, optionIndex, 1);
          }
        } else {
          ;
          nextValue[condition.key].push(optionValue);
        }
      } else if (!isSingleReSelect) {
        nextValue[condition.key] = [optionValue];
      }
      onConditionChange && onConditionChange(nextValue, condition, option);
    }
  };
  return /*#__PURE__*/React.createElement("ul", {
    className: classNames("".concat(prefixCls, "-body-conditions"), {
      active: props.tab === 'condition'
    })
  }, conditions === null || conditions === void 0 ? void 0 : _mapInstanceProperty(conditions).call(conditions, function (condition) {
    var _context2;
    var conditionValue = value[condition.key];
    return /*#__PURE__*/React.createElement("li", {
      className: "".concat(prefixCls, "-body-condition"),
      key: condition.key
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-body-condition-label")
    }, condition.label, ":"), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-body-condition-options")
    }, !condition.required && /*#__PURE__*/React.createElement("span", {
      className: classNames("".concat(prefixCls, "-body-condition-option"), {
        active: !conditionValue
      }),
      onClick: onConditionRemove.bind(null, condition.key)
    }, FilterLangMsg.unlimited), _mapInstanceProperty(_context2 = condition.options).call(_context2, function (option) {
      return option.component ? /*#__PURE__*/React.createElement(React.Fragment, {
        key: option.label
      }, /*#__PURE__*/React.createElement("span", {
        title: option.label,
        className: classNames("".concat(prefixCls, "-body-condition-option"), {
          active: conditionValue === null || conditionValue === void 0 ? void 0 : conditionValue.some(function (filterValue) {
            var _context3;
            return !_findInstanceProperty(_context3 = condition.options).call(_context3, function (option) {
              return option.value === filterValue;
            });
          })
        })
      }, option.label), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-body-condition-option-customer")
      }, option.component)) : /*#__PURE__*/React.createElement("span", {
        key: option.value,
        title: option.label || option.value,
        className: classNames("".concat(prefixCls, "-body-condition-option"), {
          active: conditionValue === null || conditionValue === void 0 ? void 0 : _includesInstanceProperty(conditionValue).call(conditionValue, option.value)
        }),
        onClick: handleConditionFilter.bind(null, condition, option)
      }, option.label || option.value);
    })), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-body-condition-addition")
    }, condition.addition));
  }));
};
export default ConditionFilter;